(function (root, factory) {
  var api = factory(root);

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  root.FAFindUs = api;
}(typeof window !== 'undefined' ? window : globalThis, function (root) {
  'use strict';

  var STORAGE_KEY = 'fa-find-us-auto-redirect-attempted';
  var INITIALISED_ATTR = 'data-find-us-initialised';

  function toFiniteNumber(value) {
    var numeric = Number(value);
    return Number.isFinite(numeric) ? numeric : 0;
  }

  function encode(value) {
    return encodeURIComponent(String(value)).replace(/[!'()*]/g, function (character) {
      return '%' + character.charCodeAt(0).toString(16).toUpperCase();
    });
  }

  function getFullAddress(location) {
    var lines = Array.isArray(location.addressLines) ? location.addressLines : [];
    var filtered = lines.filter(function (line) {
      return String(line || '').trim() !== '';
    });
    return filtered.join(', ');
  }

  function getSearchText(location) {
    var name = String(location.name || '').trim();
    var fullAddress = getFullAddress(location);
    return [name, fullAddress].filter(Boolean).join(' ');
  }

  function buildAndroidMapsUrl(location) {
    return 'geo:' + toFiniteNumber(location.latitude) + ',' + toFiniteNumber(location.longitude) + '?q=' + encode(getSearchText(location));
  }

  function buildAppleLaunchUrl(location) {
    return 'geo-navigation:///place?coordinate=' + toFiniteNumber(location.latitude) + ',' + toFiniteNumber(location.longitude);
  }

  function buildAppleMapsUrl(location) {
    var url = 'https://maps.apple.com/place?coordinate=' + toFiniteNumber(location.latitude) + ',' + toFiniteNumber(location.longitude) + '&name=' + encode(String(location.name || '')) + '&address=' + encode(getFullAddress(location));

    if (location.applePlaceId) {
      url += '&place-id=' + encode(String(location.applePlaceId));
    }

    return url;
  }

  function buildGoogleMapsUrl(location) {
    var url = 'https://www.google.com/maps/search/?api=1&query=' + encode(getSearchText(location));

    if (location.googlePlaceId) {
      url += '&query_place_id=' + encode(String(location.googlePlaceId));
    }

    return url;
  }

  function buildWazeUrl(location) {
    return 'https://waze.com/ul?q=' + encode(getSearchText(location)) + '&ll=' + toFiniteNumber(location.latitude) + ',' + toFiniteNumber(location.longitude) + '&z=17&utm_source=florenceandamelias';
  }

  function classifyPlatform(navigatorLike) {
    var navigatorValue = navigatorLike || {};
    var ua = String(navigatorValue.userAgent || '').toLowerCase();
    var platform = String(navigatorValue.platform || '').toLowerCase();
    var uaDataPlatform = navigatorValue.userAgentData && navigatorValue.userAgentData.platform ? String(navigatorValue.userAgentData.platform).toLowerCase() : '';
    var maxTouchPoints = Number(navigatorValue.maxTouchPoints || 0);

    if (ua.indexOf('android') !== -1 || uaDataPlatform === 'android') {
      return 'android';
    }

    if (
      ua.indexOf('iphone') !== -1 ||
      ua.indexOf('ipad') !== -1 ||
      ua.indexOf('ipod') !== -1 ||
      uaDataPlatform === 'ios' ||
      platform === 'iphone' ||
      platform === 'ipad' ||
      (platform === 'macintel' && maxTouchPoints > 1)
    ) {
      return 'ios';
    }

    return 'desktop';
  }

  function removeAutoRedirectParam(locationLike) {
    var nextUrl = new URL(locationLike.href);
    nextUrl.searchParams.delete('auto_redirect');
    return nextUrl.pathname + nextUrl.search + nextUrl.hash;
  }

  function getAutoLaunchUrl(location, platform) {
    if (platform === 'android') return buildAndroidMapsUrl(location);
    if (platform === 'ios') return buildAppleLaunchUrl(location);
    return '';
  }

  function readBooleanAttribute(container, name) {
    if (!container || typeof container.getAttribute !== 'function') return false;

    var value = String(container.getAttribute(name) || '').toLowerCase();
    return value === 'true' || value === '1';
  }

  function readLocation(container) {
    var raw = container.getAttribute('data-find-us-location');

    if (!raw) return null;

    try {
      return JSON.parse(raw);
    } catch (error) {
      return null;
    }
  }

  function getSessionStorage(win) {
    try {
      return win.sessionStorage;
    } catch (error) {
      return null;
    }
  }

  function hasAttempted(win) {
    var storage = getSessionStorage(win);
    return Boolean((storage && storage.getItem(STORAGE_KEY) === '1') || win.__faFindUsAutoRedirectAttempted);
  }

  function markAttempted(win) {
    var storage = getSessionStorage(win);

    win.__faFindUsAutoRedirectAttempted = true;

    if (storage) {
      try {
        storage.setItem(STORAGE_KEY, '1');
      } catch (error) {
        // Ignore storage failures. The in-memory guard still prevents repeats.
      }
    }
  }

  function maybeAutoLaunch(win, container, platform, location) {
    if (!win || !container || !location) {
      return false;
    }

    if (hasAttempted(win)) {
      return false;
    }

    if (new URL(win.location.href).searchParams.get('auto_redirect') !== '1') {
      return false;
    }

    if (platform !== 'android' && platform !== 'ios') {
      return false;
    }

    if (platform === 'android' && !readBooleanAttribute(container, 'data-auto-redirect-android')) {
      return false;
    }

    if (platform === 'ios' && !readBooleanAttribute(container, 'data-auto-redirect-ios')) {
      return false;
    }

    var targetUrl = getAutoLaunchUrl(location, platform);
    if (!targetUrl) return false;

    if (win.history && typeof win.history.replaceState === 'function') {
      try {
        win.history.replaceState({}, '', removeAutoRedirectParam(win.location));
      } catch (error) {
        // URL cleanup is best-effort only.
      }
    }

    markAttempted(win);

    var schedule = typeof win.requestAnimationFrame === 'function'
      ? win.requestAnimationFrame.bind(win)
      : function (callback) { return win.setTimeout(callback, 0); };

    schedule(function () {
      win.location.href = targetUrl;
    });

    var note = container.querySelector('[data-auto-launch-note]');
    if (note) {
      note.hidden = false;
      note.textContent = 'Trying to open your maps app...';
    }

    return true;
  }

  function fallbackCopy(text, documentLike) {
    if (!documentLike || typeof documentLike.createElement !== 'function' || typeof documentLike.execCommand !== 'function') {
      return false;
    }

    var textArea = documentLike.createElement('textarea');
    var parent = documentLike.body || documentLike.documentElement;

    if (!parent) return false;

    textArea.value = text;
    textArea.setAttribute('readonly', '');
    textArea.style.position = 'fixed';
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.opacity = '0';
    textArea.style.pointerEvents = 'none';
    parent.appendChild(textArea);
    textArea.focus();
    textArea.select();

    var succeeded = false;

    try {
      succeeded = documentLike.execCommand('copy');
    } catch (error) {
      succeeded = false;
    }

    textArea.remove();

    return succeeded;
  }

  function copyText(text, env) {
    var environment = env || root;
    var navigatorLike = environment.navigator || {};
    var documentLike = environment.document || null;

    if (navigatorLike.clipboard && typeof navigatorLike.clipboard.writeText === 'function') {
      return navigatorLike.clipboard.writeText(text).then(function () {
        return true;
      }).catch(function () {
        return fallbackCopy(text, documentLike);
      });
    }

    return Promise.resolve(fallbackCopy(text, documentLike));
  }

  function setCopyState(button, statusNode, state, message) {
    if (!button || !statusNode) return;

    button.dataset.copyState = state;
    statusNode.textContent = message || '';
    statusNode.hidden = !message;
  }

  function initCopyButton(container, location) {
    var button = container.querySelector('[data-copy-address]');
    var statusNode = container.querySelector('[data-copy-status]');

    if (!button || !statusNode) return;

    var initialLabel = button.textContent;

    button.addEventListener('click', function () {
      var copyTextValue = location.copyText || [location.name].concat(location.addressLines || []).filter(Boolean).join(', ');

      copyText(copyTextValue, root).then(function (copied) {
        if (copied) {
          button.textContent = 'Address copied';
          setCopyState(button, statusNode, 'success', 'Address copied');

          root.setTimeout(function () {
            button.textContent = initialLabel;
            statusNode.textContent = '';
            statusNode.hidden = true;
            button.dataset.copyState = 'idle';
          }, 2500);
          return;
        }

        setCopyState(button, statusNode, 'error', 'Copy failed. Select the address and copy it manually.');
      });
    });
  }

  function initMapActionCopyButtons(container) {
    container.querySelectorAll('[data-copy-map-action]').forEach(function (button) {
      var copyValue = String(button.getAttribute('data-copy-value') || '').trim();
      var successMessage = String(button.getAttribute('data-copy-success-message') || 'Value copied');
      var action = button.closest('[data-map-action-copy]');
      var statusNode = action && action.querySelector('[data-map-action-copy-status]');
      if (!copyValue) return;
      if (!statusNode) return;

      var initialLabel = button.textContent;

      button.addEventListener('click', function () {
        copyText(copyValue, root).then(function (copied) {
          if (copied) {
            button.textContent = 'Copied';
            setCopyState(button, statusNode, 'success', successMessage);

            root.setTimeout(function () {
              button.textContent = initialLabel;
              statusNode.textContent = '';
              statusNode.hidden = true;
              button.dataset.copyState = 'idle';
            }, 2500);
            return;
          }

          setCopyState(button, statusNode, 'error', 'Copy failed. Select the value and copy it manually.');
        });
      });
    });
  }

  function initQrCode(container, helperUrl) {
    var qrContainer = container.querySelector('[data-qr-code]');
    var QRCodeCtor = root.QRCode;

    if (!qrContainer || qrContainer.dataset.qrRendered === '1' || typeof QRCodeCtor !== 'function') return;

    qrContainer.innerHTML = '';
    qrContainer.dataset.qrRendered = '1';

    try {
      new QRCodeCtor(qrContainer, {
        text: helperUrl,
        width: 256,
        height: 256
      });
    } catch (error) {
      qrContainer.dataset.qrRendered = 'error';
    }
  }

  function isWebUrl(value) {
    return /^https?:\/\//i.test(String(value || '').trim());
  }

  function getActionUrl(action, platform) {
    var appUrl = String(action.getAttribute('data-find-us-action-url') || '').trim();
    var desktopUrl = String(action.getAttribute('data-find-us-action-desktop-url') || '').trim();

    if (platform === 'desktop') {
      if (desktopUrl) return desktopUrl;
      return isWebUrl(appUrl) ? appUrl : '';
    }

    return appUrl;
  }

  function closeOtherDialog(dialog) {
    if (!dialog || !dialog.open) return;

    if (typeof dialog.close === 'function') {
      dialog.close();
      return;
    }

    dialog.removeAttribute('open');
  }

  function initOtherDialog(container) {
    var openButton = container.querySelector('[data-find-us-other-open]');
    var dialog = container.querySelector('[data-find-us-other-dialog]');
    var closeButton = dialog && dialog.querySelector('[data-find-us-other-close]');

    if (!openButton || !dialog || !closeButton || openButton.dataset.findUsOtherInitialised === 'true') return;

    openButton.dataset.findUsOtherInitialised = 'true';

    openButton.addEventListener('click', function () {
      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
        return;
      }

      dialog.setAttribute('open', '');
    });

    closeButton.addEventListener('click', function () {
      closeOtherDialog(dialog);
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeOtherDialog(dialog);
    });
  }

  function setVisiblePlatform(container, platform) {
    container.setAttribute('data-platform', platform);

    container.querySelectorAll('[data-find-us-action-platforms]').forEach(function (action) {
      var supportedPlatforms = String(action.getAttribute('data-find-us-action-platforms') || '').split(',');
      var actionUrl = getActionUrl(action, platform);
      var actionLink = action.querySelector('[data-find-us-action-link]');

      if (!actionLink && action.getAttribute('data-find-us-action-link') !== null) {
        actionLink = action;
      }

      action.hidden = supportedPlatforms.indexOf(platform) === -1 || !actionUrl;
      if (actionLink && actionUrl) actionLink.setAttribute('href', actionUrl);
    });

    var otherDialog = container.querySelector('[data-find-us-other-dialog]');
    var openButton = container.querySelector('[data-find-us-other-open]');
    if (!otherDialog || !openButton) return;

    var hasVisibleOtherAction = false;
    otherDialog.querySelectorAll('[data-find-us-action-platforms]').forEach(function (action) {
      if (!action.hidden) hasVisibleOtherAction = true;
    });

    openButton.hidden = !hasVisibleOtherAction;
    if (!hasVisibleOtherAction) closeOtherDialog(otherDialog);
  }

  function initContainer(container) {
    if (!container || container.getAttribute(INITIALISED_ATTR) === 'true') return;

    var location = readLocation(container);
    if (!location) return;

    container.setAttribute(INITIALISED_ATTR, 'true');

    var platform = classifyPlatform(root.navigator || {});

    setVisiblePlatform(container, platform);
    initCopyButton(container, location);
    initMapActionCopyButtons(container);
    initOtherDialog(container);
    initQrCode(container, container.getAttribute('data-find-us-helper-url'));
    maybeAutoLaunch(root, container, platform, location);
  }

  function initAll(container) {
    var scope = container || root.document;
    if (!scope || !scope.querySelectorAll) return;

    scope.querySelectorAll('[data-find-us-page]').forEach(function (section) {
      initContainer(section);
    });
  }

  function install() {
    if (!root.document || !root.document.querySelectorAll) return;

    if (root.document.readyState === 'loading') {
      root.document.addEventListener('DOMContentLoaded', function () {
        initAll(root.document);
      });
    } else {
      initAll(root.document);
    }

    root.document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    root.addEventListener('pageshow', function () {
      initAll(root.document);
    });
  }

  install();

  return {
    buildAndroidMapsUrl: buildAndroidMapsUrl,
    buildAppleLaunchUrl: buildAppleLaunchUrl,
    buildAppleMapsUrl: buildAppleMapsUrl,
    buildGoogleMapsUrl: buildGoogleMapsUrl,
    buildWazeUrl: buildWazeUrl,
    classifyPlatform: classifyPlatform,
    copyText: copyText,
    fallbackCopy: fallbackCopy,
    getAutoLaunchUrl: getAutoLaunchUrl,
    getActionUrl: getActionUrl,
    getFullAddress: getFullAddress,
    getSearchText: getSearchText,
    initAll: initAll,
    initOtherDialog: initOtherDialog,
    maybeAutoLaunch: maybeAutoLaunch,
    readBooleanAttribute: readBooleanAttribute,
    setVisiblePlatform: setVisiblePlatform,
    removeAutoRedirectParam: removeAutoRedirectParam
  };
}));
